var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeizure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 61.9",
    enableBackground: "new 0 0 90 61.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7,
    cy: 31.9,
    r: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9,31.9L68.9,31.9c0-4.4-1.7-13.9-10.3-13.9l-20.8,1.1c-1.4,0.1-2.4,1.4-2.3,2.8c0.1,0.9,0.7,1.7,1.4,2  L9.7,24.8c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3l22.9,0.4v0L9.7,32.4c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3  l27.2,0.9c-0.8,0.4-1.3,1.1-1.4,2c-0.1,1.4,0.9,2.6,2.3,2.8l20.8,1.1C67.1,45.9,68.9,36.4,68.9,31.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,12.5c4.1-0.1,8.2,1.7,10.9,4.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,9.5c3.1-0.1,6.2,1.3,8.3,3.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3,18.2c2.6-2.3,6.2-3.5,9.6-3.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33,13.4c1.9-1.8,4.7-2.7,7.3-2.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1,49.6c-3.3,1-7.1,0.5-10.1-1.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,53.2c-2.5,0.8-5.4,0.4-7.6-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6,51.9c4.1,0.1,8.2-1.7,10.9-4.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70,54.9c3.1,0.1,6.2-1.3,8.3-3.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeizure);
export default __webpack_public_path__ + "static/media/seizure.2140fef793649f5740e58f8d58a014e8.svg";
export { ForwardRef as ReactComponent };